import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_MTP_COMPLIANCE_API} from '@app/reactQuery/apis/constants';

export const RQUseGetMTPComplianceData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_mtp_compliance_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MTP_COMPLIANCE_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};
